export enum SymbolFitMode {
    None = 0,
    MatchWidth = 1,
    MatchHeight = 2,
    Contain = 3,
  }